import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import InquiryListing from "layouts/inquiries/inquiryListing";

function Inquiries() {
  return (
    <DashboardLayout>
      <InquiryListing />
    </DashboardLayout>
  );
}

export default Inquiries;
